<template>
    <div class="search-section pt-100 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-24 pb-30">
                    <div class="row">
                <div
                    class="col-md-6 col-lg-4 pb-30"
                    v-for="card in searchResults"
                    :key="card.id"
                >
                    <div class="blog-card">
                        <div class="blog-card-image">
                            <router-link :to="card.route">
                                <img v-lazy="articleImage(card.image)" :alt="card.title">
                            </router-link>
                        </div>
                        <div class="blog-card-text">
                            <div class="blog-category">{{ categoryLabel(card.category) }}</div>
                            <h3>
                                <router-link :to="card.route">
                                    {{ card.title }}
                                </router-link>
                            </h3>
                            <div class="blog-card-entry">
                                <div class="blog-entry-text">
                                    <p>{{ card.date }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    <nav class="page-pagination" aria-label="Page Pagination">
                        <ul class="pagination">
                            <li class="page-item disabled">
                                <a class="page-link" href="news" tabindex="-1" aria-disabled="true">
                                    <i class="flaticon-left-chevron"></i>
                                </a>
                            </li>
                            <li class="page-item active">
                                <a class="page-link" href="news">1</a>
                            </li>
                            <!-- <li class="page-item" aria-current="page">
                                <a class="page-link" href="blogs">2</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="blogs">3</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="blogs">...</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="blogs">10</a>
                            </li> -->
                            <li class="page-item">
                                <a class="page-link" href="news">
                                    <i class="flaticon-right-chevron"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <!-- <div class="col-lg-4 pb-30">
                    <Sidebar />
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Search',
    computed: {
        searchResults() {
            const cards = this.$t('news.cards')
            return Array.isArray(cards) ? cards : []
        }
    },
    methods: {
        articleImage(imageName) {
            if (!imageName) return ''
            return this.$ossImg(imageName)
        },
        categoryLabel(categoryKey) {
            return this.$t(`news.categories.${categoryKey}`) || categoryKey
        }
    }
}
</script>
<style scoped>
.blog-card {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.blog-card-text {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 120px; /* Ensure the text area has a minimum height */
}

.blog-card-text h3 {
    flex: 1;
    display: flex;
    align-items: flex-start;
    min-height: 60px; /* Keep two-line titles readable */
    line-height: 1.4;
}

.blog-card-text h3 a {
    display: block;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
}

.blog-category {
    display: inline-block;
    font-weight: 700;
    
    /* padding: 4px 12px;
    border-radius: 20px;
    margin-bottom: 10px; */
    width: fit-content;
}

.blog-card-entry {
    margin-top: auto; /* Push the date to the bottom */
}
</style>
